<template>
  <div class="container mt-4">

    <CCard>
      <CCardBody>

        <h4 class="mb-4 font-weight-bold text-primary">
          Add Profile Page
        </h4>
        <ul class="nav nav-tabs mb-4">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'new' }" href="#" @click.prevent="activeTab = 'new'">
              New
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'existing' }" href="#" @click.prevent="openExistingTab">
              Existing
            </a>
          </li>
        </ul>
        <div v-if="activeTab === 'new'">
          <CRow class="mb-3">
            <CCol md="6">
              <label class="font-weight-bold d-flex align-items-center">
                Upload Files (Multiple)

                <CIcon class="ml-2 text-primary" name="cil-info" style="cursor:pointer;width:1.2rem;height:1.2rem;"
                  v-c-tooltip="{
                    content: 'Please ensure to upload the main HTML file - index.html. You may upload all additional files and images as well!',
                    placement: 'right'
                  }" />
              </label>
              <input type="file" multiple ref="fileref" class="form-control mt-2" @change="handleFileChange" />
              <small class="text-muted">
                Allowed: {{ arrayToComma(allowedExtensions) }}
              </small>
            </CCol>
          </CRow>
          <div v-if="selectedFiles.length" class="mt-3">
            <h6>Selected Files:</h6>
            <ul>
              <li v-for="(file, index) in selectedFiles" :key="index">
                {{ file.name }}
              </li>
            </ul>

          </div>

        <div class="mt-4 text-right d-flex align-items-center justify-content-end">

            <CSpinner v-if="uploading" color="primary" class="mr-3" style="width: 2rem; height: 2rem" />

            <span v-if="uploading" class="mr-3 text-primary">
              Uploading files...
            </span>

            <CButton color="info" class="mr-2" @click="resetFiles" :disabled="uploading">
              Reset
            </CButton>

            <CButton color="secondary" class="mr-2" @click="routeToDashboard" :disabled="uploading">
              Cancel
            </CButton>

            <CButton color="primary" class="mr-2" @click="onPreview" :disabled="uploading">
              Preview
            </CButton>

            <CButton color="success" :disabled="!previewCompleted || uploading" @click="onSubmit">
              Submit
            </CButton>

          </div>
         <small v-if="!previewCompleted" class="text-warning d-block mt-2 text-right">
            Please click <b>Preview</b> before submitting.
          </small>
        </div>
        <div v-if="activeTab === 'existing'">
          <h5 class="mb-3">
            Existing Profiles
          </h5>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>List of Uploaded Documents</th>
                <th>Uploaded Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="profile in existingProfiles" :key="profile.id">
                <td>{{ profile.name }}</td>
                <td>{{ formatDate(profile.date) }}</td>
              </tr>
              <tr v-if="!existingProfiles.length">
                <td colspan="3" class="text-center text-muted">
                  No profiles uploaded yet
                </td>
              </tr>
            </tbody>
          </table>
          <div class="mt-3 text-right">
            <CButton color="secondary" class="mr-2" @click="routeToDashboard">
              Cancel
            </CButton>
            <CButton color="primary" @click="previewExistingProfile">
              Preview
            </CButton>
          </div>
        </div>
      </CCardBody>
    </CCard>
    <PreviewModal :modalTitle="'Profile Preview'" modalColor="primary" :isShowPopup="previewModal.isShowPopup"
      :buttons="['Close']" :modalCallBack="closePreview" :isPreview="true" :iframe="iframe" size="xl"
      :closeOnBackdrop="false" />
    <Modal :modalTitle="validationModal.modalTitle" :modalColor="validationModal.modalColor"
      :modalContent="validationModal.modalContent" :isShowPopup="validationModal.isShowPopup"
      :buttons="validationModal.buttons" :modalCallBack="closeValidationModal" :closeOnBackdrop="false" />
    <CToaster v-if="errorMessage" :autohide="4000" position="bottom-right">
      <CToast :show="true" class="bg-danger text-white">
        {{ errorMessage }}
      </CToast>
    </CToaster>

  </div>
</template>


<script>

import { mapGetters, mapActions } from "vuex"
import PreviewModal from "@/components/reusable/PreviewModal"
import Modal from "@/components/reusable/Modal"
import { BASE_URL } from "@/service_urls";
import moment from "moment"
export default {

  name: "AddProfilePage",

  components: {
    PreviewModal,
    Modal
  },

  data() {

    return {
      uploading: false,
      existingHtmlUrl: "",
      activeTab: "new",
      existingDocuments: [],
      selectedFiles: [],
      previewCompleted: false,

      allowedExtensions: [
        "pdf", "docx", "png", "jpg", "jpeg", "doc",
        "rtf", "xlsx", "gif", "xls", "odt", "ods", "html"
      ],

      existingProfiles: [],

      errorMessage: "",

      previewModal: {
        isShowPopup: false
      },

      iframe: {
        src: "",
        loaded: true,
        isImg: false,
        pdf: { ispdf: false }
      },

      validationModal: {
        isShowPopup: false,
        modalTitle: "Validation Error",
        modalContent: "",
        modalColor: "danger",
        buttons: ["OK"]
      }

    }
  },

  computed: {
    ...mapGetters([
      "getPartnerOrgIdFromAccessToken",
      "getCustomerId"
    ])
  },

  methods: {

    ...mapActions([
      "uploadPartnerProfile",
      "getPartnerDocuments",
      "getPartnerDocumentFile",
      "showToast"
    ]),
    openExistingTab() {
      this.activeTab = "existing"
      this.loadExistingProfiles()
    },
    async loadExistingProfiles() {
      const organisation_id = this.getPartnerOrgIdFromAccessToken
      const customer_id = this.getCustomerId
      const docs = await this.getPartnerDocuments({
        organisation_id,
        customer_id
      })
      this.existingDocuments = docs
      if (!docs) return
      this.existingProfiles = docs.map(doc => ({
        id: doc.organisation_document_id,
        name: doc.document_name,
        date: doc.created_on,
        url: doc.link_to_doc
      }))
      const htmlFile = docs.find(
        doc => doc.document_name.toLowerCase() === "index.html"
      )
      if (htmlFile) {
        this.existingHtmlUrl = htmlFile.link_to_doc
      }
    },

    async previewExistingProfile() {
      const organisation_id = this.getPartnerOrgIdFromAccessToken
      const htmlDoc = this.existingDocuments.find(
        d => d.document_name.toLowerCase() === "index.html"
      )
      if (!htmlDoc) {
        console.warn("index.html not found")
        return
      }
      const htmlContent = await this.getPartnerDocumentFile({
        organisation_id,
        document_id: htmlDoc.organisation_document_id,
        preview: true
      })
      let updatedHtml = htmlContent
      this.existingDocuments.forEach(doc => {
        if (doc.document_name.toLowerCase() === "index.html") return
        const fileUrl = `${window.location.origin}${doc.link_to_doc}?preview=true`
        updatedHtml = updatedHtml.replaceAll(`./${doc.document_name}`, fileUrl)
        updatedHtml = updatedHtml.replaceAll(doc.document_name, fileUrl)
      })
      const blob = new Blob([updatedHtml], { type: "text/html" })
      const url = URL.createObjectURL(blob)
      this.iframe.src = url
      this.previewModal.isShowPopup = true
    },

    cancelExistingPreview() {
      this.iframe.src = ""
      this.previewModal.isShowPopup = false
    },

handleFileChange(event) {

  const newFiles = Array.from(event.target.files)
  this.previewCompleted = false
  newFiles.forEach(file => {
    const alreadyExists = this.selectedFiles.some(
      f => f.name === file.name
    )
    if (alreadyExists) {
      this.errorMessage = `File "${file.name}" already selected. Duplicate files are not allowed.`
    } else {
      this.selectedFiles.push(file)
    }
  })

  this.$refs.fileref.value = ""

},
    async onPreview() {

      if (!this.validateFiles()) return
      this.previewCompleted = true

      const htmlFile = this.selectedFiles.find(
        f => f.name.toLowerCase() === "index.html"
      )

      const otherFiles = this.selectedFiles.filter(
        f => f.name.toLowerCase() !== "index.html"
      )

      const htmlContent = await htmlFile.text()
      let updatedHtml = htmlContent

      otherFiles.forEach(file => {
        const blobUrl = URL.createObjectURL(file)
        const fileName = file.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const regex = new RegExp(
          `(\\.?\\/)?${fileName}`,
          "g"
        )
        updatedHtml = updatedHtml.replace(regex, blobUrl)
      })
      const finalBlob = new Blob([updatedHtml], { type: "text/html" })
      const finalUrl = URL.createObjectURL(finalBlob)

      this.iframe.src = finalUrl
      this.previewModal.isShowPopup = true
    },

    previewExisting(profile) {

      this.iframe.src = profile.url
      this.previewModal.isShowPopup = true

    },

    closePreview() {

      this.previewModal.isShowPopup = false
      this.iframe.src = ""

    },
    formatDate(date) {
      if (!date) return "--"
      return moment(date, "YYYY-MM-DDTHH:mm:ss.SSSSSS").format("DD-MM-YYYY")
    },

    async onSubmit() {

      if (!this.validateFiles()) return

      const formData = new FormData()
      const organisation_id = this.getPartnerOrgIdFromAccessToken

      formData.append("document_type_id", "")
      formData.append("customer_document_type_id", "")
      formData.append("comments", "Partner profile upload")

      this.selectedFiles.forEach(file => {
        formData.append("files", file)
      })

      try {
        this.uploading = true 

        await this.uploadPartnerProfile({
          organisation_id,
          formData
        })

        this.resetFiles()

      } catch (error) {
        console.error(error)
      } finally {
        this.uploading = false  
      }
    },

validateFiles() {

  if (!this.selectedFiles.length) {
    this.errorMessage = "Please select files."
    return false
  }
  const hasIndexHtml = this.selectedFiles.some(
    file => file.name === "index.html"
  )

  if (!hasIndexHtml) {
    this.validationModal.modalContent =
      "Please upload a file named exactly 'index.html' (lowercase)."

    this.validationModal.isShowPopup = true
    return false
  }

  const wrongIndex = this.selectedFiles.find(
    file => file.name.toLowerCase() === "index.html" && file.name !== "index.html"
  )

  if (wrongIndex) {
    this.validationModal.modalContent =
      `File "${wrongIndex.name}" is invalid. Please rename it exactly to "index.html".`

    this.validationModal.isShowPopup = true
    return false
  }

  return true
},

    arrayToComma(arr) {
      return arr.map(v => "." + v).join(", ")
    },

    resetFiles() {

      this.selectedFiles = []
      this.$refs.fileref.value = ""

    },
    routeToDashboard() {
      this.$router.push("/partner-dashboard")
    },

    closeValidationModal() {

      this.validationModal.isShowPopup = false
    }
  }
}

</script>


<style scoped>
ul {
  padding-left: 20px;
}

.nav-tabs .nav-link {
  cursor: pointer;
}
</style>